<template>
    <div class="ui-msgbox-wrap" v-if="open" ref="msgbox">
        <div class="ui-msgbox">{{msg}}</div>
    </div>
</template>

<script>

export default {
    props: {
        open: {
            type: Boolean,
            default: false
        },
        msg: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.open = true
        this.$nextTick(() => {
            document.body.appendChild(this.$refs.msgbox)
        });
    },
    created() {
        setTimeout(() => {
            this.open = false
        }, 1500)
    }
}
</script>

<style lang="scss">
.ui-msgbox-wrap {
    position: fixed;
    top: auto!important;
    bottom: 22%!important;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    z-index: 9999999;
    width: 100%;
    text-align: center;
}
.ui-msgbox {
    text-align: left;
    display: inline-block;
	border-radius: 10px;
    font-size: 24px;
    max-width: 80%;
    padding: 20px 25px;
    background-color: rgba(0, 0, 0, 0.75);
    color: #FFFFFF;
    margin: 0 auto;
    text-align: center;
}
</style>